/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  FilterModal Reducer
 */

import { payloadReducer } from '@zcode/reducers'
import { combineReducers } from 'redux'
import { handleAction } from 'redux-actions'
import {
  SET_FILTER_MODAL_TYPE,
  SET_IS_FILTER_MODAL_OPEN,
  SET_SHORT_TERM_CALENDAR_OPEN,
} from '../constants/index'

export const filterModalReducer = combineReducers({
  filterModalType: handleAction(SET_FILTER_MODAL_TYPE, payloadReducer, null),
  isFilterModalOpen: handleAction(SET_IS_FILTER_MODAL_OPEN, payloadReducer, false),
  isShortTermCalendarPickerOpen: handleAction(SET_SHORT_TERM_CALENDAR_OPEN, payloadReducer, false),
})
